import { NoticeFactory } from '@b2b/common/factories/notice';
import { ApiService } from '@b2b/common/services/api/types';
import { AuthenticationService, AuthenticationServiceModule } from '@b2b/common/services/auth/authentication.service';
import { TODO } from '@b2b/types/core/utils';
import uiRouter, { StateService } from '@uirouter/angularjs';
import angular, { IDocumentService, IFilterService, IScope } from 'angular';

UsersController.$inject = [
  '$scope',
  '$state',
  '$filter',
  '$document',
  'ApiService',
  'HelpersService',
  'NoticeFactory',
  'AuthenticationService',
];

function UsersController(
  $scope: IScope & {
    users: TODO;
    gridLink: string;
    gridImageLink: string;
    gridInviteLink: string;
    gridMenuLink: string;
    gridRolesLink: string;
    gridOptions: TODO;
  },
  $state: StateService,
  $filter: IFilterService,
  $document: IDocumentService,
  ApiService: ApiService,
  HelpersService: TODO,
  NoticeFactory: NoticeFactory,
  authenticationService: AuthenticationService
) {
  $scope.gridLink = `
    <div class="ui-grid-cell-contents"
         ng-class="col.colIndex()">
      <a data-ui-sref="application.users.detail({ id: row.entity.id })"
         role="link">{{grid.getCellValue(row, col)}}</a>
    </div>
  `;
  $scope.gridImageLink = `
    <div class="ui-grid-cell-contents"
         ng-class="col.colIndex()">
      <a class="profile-image"
         data-ui-sref="application.users.detail({ id: row.entity.id })"
         data-ng-class="{ nopic: !grid.getCellValue(row, col) }"
         role="link">
        <span class="pic"
              data-ng-if="grid.getCellValue(row, col)"
              data-ng-style="{ 'background-image': 'url(/v1/api/photos/{{ grid.getCellValue(row, col) }}/PTN)' }"></span>
      </a>
    </div>
  `;
  $scope.gridInviteLink = `
    <div class="ui-grid-cell-contents"
         ng-class="col.colIndex()">
      <a data-permit="USERS_INVITE"
         role="link"
         class="btn btn-sm btn-primary"
         data-ng-show="grid.appScope.showInviteLink(row)"
         data-ng-click="grid.appScope.resendInvite($event, row, row.entity.id)">
          <span data-ng-hide="row.entity.sent">Resend Invite</span>
          <span data-ng-show="row.entity.sent">Send Again</span>
      </a>
    </div>
  `;
  $scope.gridMenuLink = `
    <div class="ui-grid-cell-contents"
         ng-class="col.colIndex()">
      <a class="settings"
         data-ng-click="grid.appScope.showMenu($event, row, row.entity.id)"
         role="link">Settings<span class="sr-only">- Opens menu</span>
      </a>
    </div>
  `;
  $scope.gridRolesLink = `
    <div class="ui-grid-cell-contents"
         ng-class="col.colIndex()">
      <div class="role"
           data-ng-repeat="role in COL_FIELD">{{ role.name }}</div>
    </div>
  `;

  const ctrl = {
    initted: false,

    model: [],
    filtered: [] as TODO[],
    currentUser: {} as TODO,
    menu: {
      x: 3000,
      y: 0,
      width: 120,
      shown: false,
    },
    departments: [] as TODO[],
    permissions: [] as TODO[],
    titles: [] as TODO[],
    status: ['Unconfirmed', 'Active'],

    paging: {
      pageSize: 25,
      currentPage: 1,
      totalItems: 0,
      totalPages: 1,
    },

    filter: {
      department: '',
      title: '',
      role: '',
    } as TODO,

    searchQuery: '',
    notice: new NoticeFactory(),

    init: function () {
      $scope.$emit('Application::contentTitleChange', {
        title: 'Manage Users',
        buttonRight: {
          label: 'New User',
          action: () => {
            ctrl.invite();
          },
        },
      });

      $scope.$emit('Application::viewChange', { view: 'full' });
      $scope.$on('AppController::invite::success', ctrl.onInviteSuccess);
      $scope.$on('$destroy', $scope.$watch('users.filter.department', ctrl.onFilterDepartmentUpdate));
      $scope.$on('$destroy', $scope.$watch('users.filter.title', ctrl.onFilterTitleUpdate));
      $scope.$on('$destroy', $scope.$watch('users.filter.role', ctrl.onFilterRoleUpdate));
      $scope.$on('$destroy', ctrl.onDestroy);
      $document.on('click', ctrl.onDocumentClick);
      ctrl.initData();
    },

    initData: function () {
      ctrl
        .initDepartments()
        .then((response) => ctrl.initPermissions(response))
        .then((response) => ctrl.initTitles(response))
        .then((response) => ctrl.initUsers(response))
        .then((response) => ctrl.success.initData(response))
        .catch(() => {
          // noop
        });
    },

    initDepartments: function () {
      return ApiService.departments.list({
        page: 1,
        pageSize: -1,
        sortDirection: 'asc',
        sortField: 'name',
      });
    },

    // Requires chained response from initDepartments
    initPermissions: function (response) {
      ctrl.departments = response.data.payload.list;
      return ApiService.userProxy.permissions.list(HelpersService.getPaginator());
    },

    // Requires chained response from initPermissions
    initTitles: function (response) {
      ctrl.permissions = response.data.payload.list;
      return ApiService.userProxy.titles.list(HelpersService.getPaginator());
    },

    // Requires chained response from initTitles
    initUsers: function (response) {
      ctrl.titles = response.data.payload;

      if ($state.params && $state.params.deptid) {
        ctrl.filter.department = ctrl.findDepartment(parseInt($state.params.deptid, 10));
      }

      if ($state.params && $state.params.roleid) {
        ctrl.filter.role = ctrl.findRole(parseInt($state.params.roleid, 10));
      }

      if ($state.params && $state.params.title) {
        ctrl.filter.title = ctrl.findTitle($state.params.title);
      }

      return ctrl.loadUsers();
    },

    loadUsers: function () {
      const props = HelpersService.getPaginator();
      // Returns either filtered user list if query params exist or all users
      if ($state.params && ($state.params.deptid || $state.params.role || $state.params.title)) {
        props.departmentId = ctrl.filter.department ? ctrl.filter.department.id || null : null;
        props.jobTitle = ctrl.filter.title || null;
        props.roleId = ctrl.filter.role ? ctrl.filter.role.id || null : null;
      }

      return ApiService.userProxy.list(props);
    },

    invite: function () {
      $scope.$emit('AppController::users::invite');
    },

    search: function (page?: number) {
      const filtered = $filter('filter')(ctrl.model, (user: TODO) => {
        const first = user.firstName || '';
        const last = user.lastName || '';
        const value = (first + ' ' + last + ' ' + user.email).toLowerCase();
        return value.indexOf(ctrl.searchQuery.toLowerCase()) !== -1 ? user : null;
      });

      ctrl.paging.currentPage = page ? page : 1;
      ctrl.filtered = filtered.slice(0, ctrl.paging.pageSize);
      ctrl.updateIndicators(filtered);
      console.log('UsersController::search', ctrl.filtered);
    },

    findDepartment: function (id) {
      for (let i = 0, ii = ctrl.departments.length; i < ii; i++) {
        if (id === ctrl.departments[i].id) {
          return ctrl.departments[i];
        }
      }

      return false;
    },

    findRole: function (id) {
      for (let i = 0, ii = ctrl.permissions.length; i < ii; i++) {
        if (id === ctrl.permissions[i].id) {
          return ctrl.permissions[i];
        }
      }

      return false;
    },

    findTitle: function (title) {
      const index = ctrl.titles.indexOf(title);
      return index === 0 ? ctrl.titles[index] : false;
    },

    showMenu: function (e, row) {
      const menu = $('#users-list-menu')!;
      const el = $(e.currentTarget);
      const parentOffset = el.parents('.users').offset()!;
      const offset = el.offset()!;
      const x = offset.left - menu.width()! - parentOffset.left + el.width()!;
      const y = offset.top - parentOffset.top + el.height()!;

      e.stopPropagation();

      el.addClass('show');

      ctrl.currentUser = ctrl.filtered[row.rowIndex];
      ctrl.menu.x = x;
      ctrl.menu.y = y;
      ctrl.menu.shown = true;
      console.log('UsersController::showMenu', ctrl.currentUser, e.target, $(e.target).offset());
    },

    hideMenu: function () {
      console.log('UsersController::hideMenu', ctrl.menu);
      $('.settings.show').removeClass('show');
      ctrl.menu.x = -3000;
      ctrl.menu.shown = false;
    },

    view: function () {
      $state.go('application.users.detail', { id: ctrl.currentUser.id });
    },

    edit: function () {
      $state.go('application.users.edit', { id: ctrl.currentUser.id });
    },

    deactivate: function () {
      ctrl.currentUser.active = false;
      ApiService.user
        .update(ctrl.currentUser)
        .then((response) => ctrl.success.deactivate(response))
        .catch(() => {
          // noop
        });
    },

    activate: function () {
      ctrl.currentUser.active = true;
      ApiService.user
        .update(ctrl.currentUser)
        .then((response) => ctrl.success.activate(response))
        .catch(() => {
          // noop
        });
    },

    resendInvite: function (e, row, id) {
      ApiService.userProxy
        .resendInvite(id)
        .then((response) => {
          ctrl.filtered[row.rowIndex].sent = true;
          ctrl.success.resendInvite(response);
        })
        .catch(() => {
          // noop
        });
    },

    firstPage: function () {
      ctrl.paging.currentPage = 1;
      ctrl.updatePage();
    },

    nextPage: function () {
      if (ctrl.paging.currentPage < Math.ceil(ctrl.paging.totalItems / ctrl.paging.pageSize)) {
        ctrl.paging.currentPage++;
        ctrl.updatePage();
      }
    },

    prevPage: function () {
      if (ctrl.paging.currentPage > 1) {
        ctrl.paging.currentPage--;
        ctrl.updatePage();
      }
    },

    lastPage: function () {
      ctrl.paging.currentPage = ctrl.paging.totalPages;
      ctrl.updatePage();
    },

    updatePage: function () {
      ctrl.filtered = ctrl.model.slice(
        (ctrl.paging.currentPage - 1) * ctrl.paging.pageSize,
        ctrl.paging.pageSize * ctrl.paging.currentPage
      );
    },

    updateIndicators: function (data) {
      ctrl.paging.totalItems = data.length;
      ctrl.paging.totalPages = Math.ceil(ctrl.paging.totalItems / ctrl.paging.pageSize);
    },

    getUsers: function () {
      ApiService.userProxy
        .list(HelpersService.getPaginator())
        .then((response) => ctrl.success.getUsers(response))
        .catch(() => {
          // noop
        });
    },

    success: {
      initData: function (response) {
        ctrl.initted = true;
        ctrl.model = response.data.payload.list;
        ctrl.paging.totalItems = ctrl.model.length;
        ctrl.paging.totalPages = Math.ceil(ctrl.paging.totalItems / ctrl.paging.pageSize);

        console.log('UsersController::success::initData', $state.params);
        if ($state.params && $state.params.page) {
          ctrl.paging.currentPage = parseInt($state.params.page, 10);
        } else {
          ctrl.paging.currentPage = 1;
        }

        // Perform a search if there is a query parmeter
        if ($state.params && $state.params.search) {
          ctrl.searchQuery = $state.params.search;
          ctrl.search(ctrl.paging.currentPage);
        } else if (ctrl.paging.currentPage > 1) {
          ctrl.updatePage();
        } else {
          ctrl.firstPage();
        }
      },

      getUsers: function (response) {
        ctrl.model = response.data.payload;
        ctrl.paging.totalItems = ctrl.model.length;
        ctrl.paging.totalPages = Math.ceil(ctrl.paging.totalItems / ctrl.paging.pageSize);
        ctrl.firstPage();
      },

      deactivate: function (response) {
        for (let i = 0, ii = ctrl.filtered.length; i < ii; i++) {
          if (ctrl.filtered[i].id === ctrl.currentUser.id) {
            ctrl.filtered[i].active = false;
            ctrl.filtered[i].status = 'Deactivated';
            break;
          }
        }
      },

      activate: function (response) {
        for (let i = 0, ii = ctrl.filtered.length; i < ii; i++) {
          if (ctrl.filtered[i].id === ctrl.currentUser.id) {
            ctrl.filtered[i].active = true;
            ctrl.filtered[i].status = 'Active';
            break;
          }
        }
      },

      resendInvite: function (response) {},

      onFilterUpdate: function (response) {
        ctrl.success.getUsers(response);
        ctrl.search();
      },
    },

    onDestroy: function () {
      ctrl.hideMenu();
      $scope.$emit('Application::viewChange', { view: 'sidebar' });
      $document.off('click');
    },

    onFilterDepartmentUpdate: function () {
      const props = HelpersService.getPaginator();

      if (ctrl.initted) {
        props.departmentId = ctrl.filter.department ? ctrl.filter.department.id || null : null;
        props.jobTitle = ctrl.filter.title || null;
        props.roleId = ctrl.filter.role ? ctrl.filter.role.id || null : null;
        ApiService.userProxy
          .list(props)
          .then((response) => ctrl.success.onFilterUpdate(response))
          .catch(() => {
            // noop
          });
      }
    },

    onFilterTitleUpdate: function () {
      const props = HelpersService.getPaginator();

      if (ctrl.initted) {
        props.departmentId = ctrl.filter.department ? ctrl.filter.department.id || null : null;
        props.jobTitle = ctrl.filter.title || null;
        props.roleId = ctrl.filter.role ? ctrl.filter.role.id || null : null;
        ApiService.userProxy
          .list(props)
          .then((response) => ctrl.success.onFilterUpdate(response))
          .catch(() => {
            // noop
          });
      }
    },

    onFilterRoleUpdate: function () {
      const props = HelpersService.getPaginator();

      if (ctrl.initted) {
        props.departmentId = ctrl.filter.department ? ctrl.filter.department.id || null : null;
        props.jobTitle = ctrl.filter.title || null;
        props.roleId = ctrl.filter.role ? ctrl.filter.role.id || null : null;
        ApiService.userProxy
          .list(props)
          .then((response) => ctrl.success.onFilterUpdate(response))
          .catch(() => {
            // noop
          });
      }
    },

    onDocumentClick: function (e) {
      console.log('UsersController::onDocumentClick', e);
      if (ctrl.menu.shown) {
        ctrl.hideMenu();
        $scope.$apply();
      }
    },

    onInviteSuccess: function (e, data) {
      console.log('UsersController::onInviteSuccess');
      ctrl
        .loadUsers()
        .then((response) => ctrl.success.initData(response))
        .catch(() => {
          // noop
        });
    },

    onDataGridPaginate: function () {},

    onDataGridSortChange: function () {},
  };

  $scope.gridOptions = {
    multiselect: false,
    enableRowSelection: false,
    paginate: false,
    rowHeight: '42',
    appScopeProvider: {
      showInviteLink: (row: { entity: { status: string } }) => {
        if (authenticationService.isSSO()) {
          return false;
        }

        return row.entity.status === 'Unconfirmed';
      },
      resendInvite: ctrl.resendInvite,
      showMenu: ctrl.showMenu,
    },

    columnDefs: [
      {
        field: 'profileImage',
        displayName: 'Photo',
        cellTemplate: $scope.gridImageLink,
        width: 48,
      },
      {
        field: 'lastName',
        displayName: 'Last Name',
        cellTemplate: $scope.gridLink,
      },
      {
        field: 'firstName',
        displayName: 'First Name',
        cellTemplate: $scope.gridLink,
      },
      {
        field: 'department',
        displayName: 'Department',
      },
      {
        field: 'userName',
        displayName: 'Username',
        cellTemplate: $scope.gridLink,
      },
      {
        field: 'email',
        displayName: 'Email',
        cellTemplate: $scope.gridLink,
      },
      {
        field: 'phoneNumber',
        displayName: 'Phone Number',
      },
      {
        field: 'title',
        displayName: 'Job Title',
      },
      {
        field: 'status',
        displayName: 'Status',
      },
      {
        field: 'roles',
        displayName: 'Role',
        cellTemplate: $scope.gridRolesLink,
      },
      {
        field: 'resendInvite',
        displayName: 'Invite',
        cellTemplate: $scope.gridInviteLink,
      },
      {
        field: 'menu',
        name: 'menuLink',
        displayName: 'Menu',
        cellTemplate: $scope.gridMenuLink,
        width: 32,
      },
    ],
  };

  $scope.users = ctrl;
  ctrl.init();
}

export const UsersControllerModule = angular
  .module('acme.view.application.users.controllers', [
    uiRouter,
    'ui.grid',
    'ui.grid.autoResize',
    'acme.common.factory.notice',
    'acme.common.service.api',
    'acme.common.service.helpers',
    AuthenticationServiceModule,
  ])
  .controller('UsersController', UsersController).name;
